import React from 'react'
import { AuthConsumer } from '../contexts/auth'

export function withAuthConsumer ( Component ) {
  const withAuthConsumer = ( props ) => {
    return (
      <AuthConsumer>
        {authConsumer => <Component {...props} authConsumer={authConsumer} /> }
      </AuthConsumer>
    )
  }
  return withAuthConsumer
}


// WEBPACK FOOTER //
// ./src/hocs/withAuthConsumer.js